export const CHECKOUT_URL = 'https://conduca-infantil.impultienda.ar/checkout'

export const MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/qLyucPxAtV6uZpLzFJLF4o/image.png'

export const prices = {
  before: '$47.990',
  now: '$17.990',
  saving: '$30.000',
}

export const stats = [
  { value: '5', label: 'Guías prácticas' },
  { value: '3', label: 'Bonos incluidos' },
  { value: '100%', label: 'Digital' },
]

export const productPages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/ey4XY3Pw6LpackEx4uhdrW/Captura_de_pantalla_2026-09-30_a_la(s)_6.28.28_p._m..png',
    tag: 'Guía 1',
    title: 'Entendé qué te está pasando',
    alt: 'Página de la Guía 1: ¿Qué está cambiando en tu cuerpo? Explica cómo fluctúan el estrógeno y la progesterona y su efecto en sueño, temperatura, ánimo y ciclo.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7yuWkQGVma6cdeCDH2HC97/Captura_de_pantalla_2026-09-30_a_la(s)_6.29.40_p._m..png',
    tag: 'Guía 2',
    title: 'Tus síntomas, uno por uno',
    alt: 'Página de la Guía 2: Mi cuerpo está cambiando. Explica cambios en la forma corporal, la importancia del músculo e incluye un ejercicio para marcar qué notaste más.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2LUqfJNE9D13QrjEt3hpmW/Captura_de_pantalla_2026-09-30_a_la(s)_6.30.36_p._m..png',
    tag: 'Guía 3',
    title: 'Qué podés hacer desde hoy',
    alt: 'Página de la Guía 3: Tu cuerpo necesita movimiento, no castigo. Compara lo que no necesitás con lo que sí podés buscar y muestra ejemplos de movimiento cotidiano.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/e7zoVEERJmfSvRoV4NJFQS/Captura_de_pantalla_2026-09-30_a_la(s)_6.31.37_p._m..png',
    tag: 'Bono 1',
    title: 'SOS Sofocos + Noche',
    alt: 'Página del Bono 1: Si te despertás con calor. Secuencia de 4 pasos: me despierto, me acomodo o refresco, bajo revoluciones y vuelvo a descansar.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/raitMJUktBytpcGcvXkasJ/Captura_de_pantalla_2026-09-30_a_la(s)_6.31.55_p._m..png',
    tag: 'Bono 2',
    title: '30 Comidas Fáciles +40',
    alt: 'Página del Bono 2: Desayunos. Recetas de yogur con fruta, avena y semillas, y tostadas con huevo y fruta, con ingredientes y preparación.',
  },
]

export const symptoms = [
  'Todo parece estar pasando al mismo tiempo.',
  'Cada fuente te recomienda algo diferente.',
  'No sabés qué cambio priorizar primero.',
  'Intentar hacer todo termina abrumándote.',
]

export const steps = ['Entendé', 'Identificá', 'Priorizá', 'Actuá', 'Creá tu Plan +40']

export const guides = [
  {
    title: 'ENTENDÉ QUÉ TE ESTÁ PASANDO',
    subtitle: 'Primero entendé. Después decidí qué hacer.',
    desc: 'Comprendé esta etapa, reconocé tus principales cambios y empezá a identificar qué merece más atención.',
  },
  {
    title: 'TUS SÍNTOMAS, UNO POR UNO',
    subtitle: 'Buscá directamente lo que hoy te preocupa.',
    desc: 'Sofocos, sueño, cansancio, concentración, cambios emocionales, cuerpo e intimidad: qué puede estar pasando y qué podés hacer.',
  },
  {
    title: 'QUÉ PODÉS HACER DESDE HOY',
    subtitle: 'Pasá de la información a la acción.',
    desc: 'Encontrá acciones simples sobre alimentación, movimiento, fuerza, descanso, hidratación y recuperación.',
  },
  {
    title: 'MI PLAN +40',
    subtitle: 'Convertí todo en un plan pensado para vos.',
    desc: 'Elegí tus prioridades, definí tus primeras acciones y registrá qué te ayuda y qué necesitás ajustar.',
  },
  {
    title: 'TU BIENESTAR EMOCIONAL +40',
    subtitle: 'Porque esta etapa también se siente por dentro.',
    desc: 'Comprendé mejor la irritabilidad, la preocupación, el agotamiento mental y esa sensación de “ya no me siento como antes”.',
  },
]

// Add an `image` URL to any bonus to show a real page preview inside its block.
export const bonuses: { title: string; lead: string; desc: string; image?: string }[] = [
  {
    title: 'SOS SOFOCOS + NOCHE',
    lead: 'Para esas noches en las que el calor interrumpe tu descanso.',
    desc: 'Qué hacer cuando aparece un sofoco, cómo preparar mejor la noche y cómo observar posibles patrones.',
  },
  {
    title: '30 COMIDAS FÁCILES +40',
    lead: 'Para cuando no sabés qué preparar.',
    desc: '30 opciones con cantidades, ingredientes y preparación breve para desayunos, comidas y momentos en los que necesitás resolver rápido.',
  },
  {
    title: 'PREPARÁ TU CONSULTA',
    lead: 'Para llegar sabiendo qué querés contar y preguntar.',
    desc: 'Organizá tus principales cambios, frecuencia, ciclo, medicamentos, antecedentes y dudas antes de hablar con un profesional.',
  },
]

export const faqs = [
  {
    q: '¿Tengo que leer las 5 guías antes de empezar?',
    a: 'No. El Kit está organizado para que puedas avanzar progresivamente y consultar primero las secciones y herramientas que más necesitás.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'Después de completar tu compra vas a recibir acceso al material digital para que puedas empezar inmediatamente.',
  },
  {
    q: '¿Es un producto físico?',
    a: 'No. Es un producto 100% digital.',
  },
  {
    q: '¿Puedo consultarlo desde el celular?',
    a: 'Sí. El material fue diseñado para poder consultarlo cómodamente desde celular, tablet o computadora.',
  },
  {
    q: '¿Qué pasa si recién estoy empezando a notar cambios?',
    a: 'Justamente el Kit fue pensado también para mujeres que están empezando a atravesar esta etapa y todavía no entienden bien qué puede estar pasando.',
  },
  {
    q: '¿Y si mi principal problema son los sofocos?',
    a: 'Vas a encontrar contenido específico sobre sofocos dentro de las guías y además recibís el Bono SOS Sofocos + Noche.',
  },
  {
    q: '¿Y si lo que más me cuesta es dormir?',
    a: 'También vas a encontrar herramientas relacionadas con descanso, preparación de la noche y despertares nocturnos.',
  },
  {
    q: '¿Incluye herramientas prácticas?',
    a: 'Sí. No es solamente material teórico. Incluye ejercicios, registros, planes, herramientas para organizar tus síntomas y recursos que podés empezar a utilizar desde el primer día.',
  },
  {
    q: '¿Incluye alimentación?',
    a: 'Sí. Además de contenido sobre alimentación dentro de las guías, recibís el Bono 30 Comidas Fáciles +40.',
  },
  {
    q: '¿Reemplaza el acompañamiento profesional?',
    a: 'No. El material es educativo e informativo y no reemplaza una evaluación, diagnóstico o tratamiento profesional.',
  },
  {
    q: '¿Tiene garantía?',
    a: 'Sí. Tenés 7 días para explorar el material y decidir si el Kit es para vos.',
  },
]

export const costs = [
  ['Buscar cada síntoma por separado', 'Más información, pero poca claridad'],
  ['Probar consejos diferentes cada semana', 'No saber qué realmente te sirve'],
  ['Intentar cambiar todo al mismo tiempo', 'Sentirte abrumada y abandonar'],
  ['No registrar lo que estás sintiendo', 'Olvidarte de información importante'],
  ['Llegar a una consulta sin organizar tus dudas', 'No aprovechar todo lo que querías preguntar'],
  ['Seguir preguntándote qué te está pasando', 'Más incertidumbre frente a esta etapa'],
]
